import { ImportCsvModal } from 'iron-forge-react-modules';
import * as types from './types';



export const propertyName2Comment: Record<types.NetSuiteShipItemsPropertyName, string> = {
  internalId: 'internalId',
  name: 'name',
  displayCode: 'displayCode',
  description: 'description',
  subsidiary: 'subsidiary'
};



export const propertyName2Data: Record<types.NetSuiteShipItemsPropertyName, ImportCsvModal.IFormatTypeData> = {
  internalId: {
    example: "188",
    properFormat: "",
    fnValidate: () => true
  },
  name: {
    example: "AAA Express - Neighborhood Beverage Co.",
    properFormat: "",
    fnValidate: () => true
  },
  displayCode: {
    example: "AAA Express",
    properFormat: "",
    fnValidate: () => true
  },
  description: {
    example: "AEIS",
    properFormat: "",
    fnValidate: () => true
  },
  subsidiary: {
    example: "Neighborhood Beverage Co.",
    properFormat: "",
    fnValidate: () => true
  }
};



export const columnDefs = [
  {
    id: 'Internal ID',
    label: 'Internal ID',
    isRequired: true,
    formatType: undefined
  },
  {
    id: 'Description',
    label: 'Description',
    isRequired: true,
    formatType: undefined
  }
];
